export abstract class BaseOrderItem {
	public abstract set Selected(value: boolean | undefined);

	public abstract get Selected(): boolean | undefined;
}
